var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-list"},_vm._l((_vm.transactions),function(t){return _c('transaction-chip',{key:t.id,attrs:{"type":t.transactionType,"trackingNumber":t.trackingNumber},on:{"clicked":_vm.clicked}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }